module.exports = __webpack_public_path__ + "img/caixun_logo3.34a300a2.png";